import PageHeader from '@/components/layout/PageHeader';
import ProjectsBento from '@/components/marketing/ProjectsBento';
import BeforeAfter from '@/components/marketing/BeforeAfter';
import CtaBanner from '@/components/marketing/CtaBanner';

export default function ProjectsPage() {
  return (
    <>
      <PageHeader
        chapter="Chapter 004"
        eyebrow="Gallery"
        title={<>Selected work,<br />quietly delivered.</>}
        blurb="Kitchens. Baths. Additions. Ground-up builds. A few we're most proud of — many more available on request."
      />
      <ProjectsBento />
      <BeforeAfter />
      <CtaBanner place="projects-page" />
    </>
  );
}
